import type { Screens } from "@/styled";

export const screens: Screens = {
  phone: "min-width: 0px",
  largePhone: "min-width: 426px",
  tablet: "min-width: 768px",
  desktop: "min-width: 1024px",
  largeDesktop: "min-width: 1280px",
  wideDesktop: "min-width: 1440px",
  wideScreen: "min-width: 1600px",
  extraWideScreen: "min-width: 1728px",
  extraWideDesktop: "min-width: 2160px",
};
